import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { map } from 'rxjs/operators';
import { ManagementTypes } from '@models/matter';

@Component({
	selector: 'app-sale-condo',
	templateUrl: './condo.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class CondoComponent {
	public shouldDisplayCondoManagement$ = inject(Store)
		.select(SelectedMatter.condoCorporation)
		.pipe(
			map(
				(condo) =>
					condo?.condoCorp &&
					condo.managementType === ManagementTypes.MANAGEMENT_COMPANY,
			),
		);
	public shouldDisplayManagementType$ = inject(Store)
		.select(SelectedMatter.condoCorporation)
		.pipe(map((condo) => condo?.condoCorp && !condo.management));
}
